import { createBrowserHistory } from "history";

const customHistory = createBrowserHistory({ window });

export default customHistory;
